(() => {
  var airbrake = new airbrakeJs.Client({
    projectId: 179970,
    projectKey: 'f313b8468dd91bbdac891ae85de83056'
  });

  airbrake.addFilter(function (notice) {
    notice.context.environment = 'production';
    return notice;
  });

    $(function () {
        var user = $('#current-user');
        if (user.data('user-id') != null) {
            var fullName = user.data('username'),
                firstName = fullName.substring(0, (fullName.indexOf(' ') > 1 ? fullName.indexOf(' ') : fullName.length));
        }
    }());

    angular.module('app.core').config(function ($provide, $sceDelegateProvider) {
        $provide.decorator("$exceptionHandler", ['$delegate', function ($delegate) {
            return function (exception, cause) {
                $delegate(exception, cause);
            }
        }]);

        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Fix for allowing directives to load funnel templateUrl in Docraptor
            'https://app.audiencereport.com/assets/js/app/components/**',
            'https://app-rc.audiencereport.com/assets/js/app/components/**',
            'app.audiencereport.com/assets/js/app/components/**'
        ]);

        // Highchart config
        // Format number in the tooltip
        Highcharts.Point.prototype.tooltipFormatter = function (useHeader) {
            var point = this,
                series = point.series;
            return ['<span style="color:' + series.color + '">', (point.name || series.name), '</span>: ',
                (!useHeader ? ('<b>x = ' + (point.name || point.x) + ',</b> ') : ''),
                '<b>', (!useHeader ? 'y = ' : ''), Highcharts.numberFormat(point.y, 0), '</b>'].join('');
        };
    });
})();
